<template>
  <div class="main-contract-number-tag" v-loading="isLoading">
    <div :class="[!isIframe ? 'title' : 'isIframe']">
      <span v-if="!isIframe" :style="{ float: 'left', paddingRight: '20px' }"
        >主合同号标签配置</span
      >
      <div
        :style="{
          float: 'left',
          padding: '0 10px 0px 10px',
        }"
      >
        <el-button type="primary" size="mini" @click="handleAdd"
          >新增</el-button
        >
        <el-button type="primary" size="mini" @click="downloadFile"
          >导出</el-button
        >
      </div>
      <div :style="{ float: 'right', paddingRight: '10px' }">
        <el-form
          ref="searchForm"
          :model="searchForm"
          label-width="0px"
          style="display: inline-block; width: 380px"
          class="search-form-tag"
        >
          <el-form-item
            label=""
            style="display: inline-block; margin-bottom: 0"
          >
            <el-input
              v-model="searchForm.orgNo"
              placeholder="商场编码"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=""
            style="display: inline-block; margin-bottom: 0"
          >
            <el-input
              v-model="searchForm.no"
              placeholder="取号门店编码/组织编码"
              size="mini"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" size="mini" @click="handleSearch"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="setting-item">
      <table-select-all
        :selectable="false"
        class="detal-table"
        byKey="productId"
        ref="selectTable"
        :tableData="tableData"
        :initData="getCustomerMainContactLabelQueryPage"
        :maxHeight="null"
        emptyText="暂无数据"
      >
        <el-table-column
          prop="orgNo"
          label="商场编码"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.orgId ? orgIdMap[scope.row.orgId] : scope.row.orgNo }}
          </template>
        </el-table-column>
        <el-table-column
          prop="no"
          label="取号门店/商场编码"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="取号门店/商场"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop=""
          label="品牌品类"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.brandName }}{{ scope.row.categoryName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="label"
          label="主合同号标签"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="lastUpdator"
          label="最后更新人"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="lastUpdateDt"
          label="最后修改时间"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.lastUpdateDt | dateFormat("yyyy-MM-dd HH:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="lastUpdateDt"
          label="操作"
          min-width="250"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleEdit(scope.row, 'edit')"
              >编辑</el-button
            >
            <el-button
              v-if="scope.row.no !== currentUser.orgNo"
              type="primary"
              size="mini"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="handleEdit(scope.row, 'view')"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </table-select-all>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      title="主合同号取号标签"
      :visible.sync="editDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      append-to-body
      class="edit-dialog-tag"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="editRules"
        label-width="150px"
        class="edit-dialog-form"
      >
        <el-form-item label="取号标签配置维度">
          <el-radio-group
            :disabled="dialogEdit"
            v-model="editForm.radio"
            @change="handleRadioChange"
          >
            <el-radio :label="1">商场</el-radio>
            <el-radio :label="2">门店</el-radio>
          </el-radio-group>
        </el-form-item>
        <div style="padding: 20px 20px 0 0; border: 1px solid #e4e7ed">
          <el-row>
            <el-col :span="12">
              <el-form-item label="商场编码" prop="orgNo">
                <el-row>
                  <el-col :span="isOppein && editType !== 'edit' ? 16 : 24">
                    <el-input
                      size="small"
                      width="128px"
                      :class="[
                        { 'get-org-btn': isOppein && editType !== 'edit' },
                      ]"
                      :disabled="!isOppein || editType === 'edit'"
                      v-model="editForm.orgNo"
                    ></el-input>
                  </el-col>
                  <el-col :span="8" v-if="isOppein && editType !== 'edit'">
                    <el-button
                      v-if="isOppein && editType !== 'edit'"
                      type="primary"
                      size="mini"
                      @click="selectOrgByNo"
                      >确定</el-button
                    >
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="取号门店/商场" prop="no" label-width="120px">
                <OrganizationSelect
                  ref="orgSelect"
                  placeholder="请选择取号门店/商场"
                  :value="editForm.id"
                  :orgId="editForm.orgId"
                  :disabled="editForm.radio === 1 || dialogEdit"
                  :multiple="false"
                  @onNodeClick="
                    (data) => {
                      onNodeClick(data);
                    }
                  "
                  @onCheckChange="
                    (data) => {
                      onCheckChange(data);
                    }
                  "
                  white="shop"
                ></OrganizationSelect>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="取号门店/商场编码">
                <el-input
                  size="small"
                  v-model="editForm.no"
                  disabled
                  placeholder="取号门店/商场编码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="取号标签" prop="label" label-width="120px">
                <el-input
                  size="small"
                  v-model="editForm.label"
                  placeholder="请输入取号标签（最多10个字符）"
                  maxlength="10"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="品牌品类">
                <el-select
                  v-model="editForm.brandCategoryList"
                  multiple
                  size="small"
                  :disabled="disabledBrandCategory || dialogEdit"
                  placeholder="请选择品牌品类"
                  style="width: 100%"
                  @change="handleBrandCategoryChange"
                  @visible-change="loadBrandCategoryList"
                >
                  <el-option
                    v-for="category in brandCategoryList"
                    :key="category.value"
                    :label="category.label"
                    :value="category.value"
                  ></el-option>
                </el-select>
                <span style="color: red; font-size: 12px"
                  >不选择品牌品类则默认为全品类</span
                >
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer" v-if="editType !== 'view'">
        <el-button @click="cancelEditDialog">取消</el-button>
        <el-button type="primary" @click="submitEditForm">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reqGetCurrentUser, getDict } from "@oppein/op-utils";
import tableSelectAll from "@/components/tableSelectAll";
import { customerMainContactLabelQueryPage } from "@/api/designordercenter/customerMainContactLabel/queryPage/post.js";
import { queryPageByOrgPermissions } from "@/api/designordercenter/customerMainContactLabel/queryPageByOrgPermissions/post.js";

import { reqGetOrgBrandCategory } from "@/api/designapi/design/insideProcessOrder/getOrgBrandCategory/get.js";
import { saveByOrgPermissions } from "@/api/designordercenter/customerMainContactLabel/saveByOrgPermissions/post.js";
import { updateByOrgPermissions } from "@/api/designordercenter/customerMainContactLabel/updateByOrgPermissions/post.js";
import { deleteByIdValidateOrgPermissions } from "@/api/designordercenter/customerMainContactLabel/deleteByIdValidateOrgPermissions/post.js";

import { api, linkPost } from "@/api/index";
import OrganizationSelect from "@/components/OrganizationSelect";

export default {
  name: "CustomerDataPackageSetting",
  data() {
    return {
      isLoading: false, // 控制加载状态
      // 客户资料包
      customerDataPackage: {},
      categoryDialogVisible: false,
      categoryDialogRow: null,
      categoryOptions: [],
      tableData: [],
      // 新增编辑弹窗相关数据
      editDialogVisible: false,
      disabledBrandCategory: false,
      editForm: {
        id: "",
        no: "",
        name: "",
        brandCategoryList: [],
        label: "",
        radio: null,
        orgId: "",
        orgNo: "",
        shopId: "",
        type: "",
      },
      searchForm: {
        no: "",
        orgNo: "",
      },
      editRules: {
        radio: [
          {
            required: true,
            message: "请选择取号标签配置维度",
            trigger: "blur",
          },
        ],
        orgNo: [{ required: true, message: "请输入商场编码", trigger: "blur" }],
        no: [{ required: true, message: "请选择组织编码", trigger: "blur" }],
        label: [
          { required: true, message: "请输入取号标签", trigger: "blur" },
          { max: 10, message: "取号标签不能超过10个字符", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value && /\s/.test(value)) {
                callback(new Error("不能包含空格"));
              } else if (value && !/^[a-zA-Z0-9\u4e00-\u9fa5]+$/.test(value)) {
                callback(new Error("只允许输入数字、字母和中文"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      organizationList: [], // 组织列表
      brandCategoryList: [], // 品牌品类列表
      brandCategoryListCopy: [], // 品牌品类列表副本
      currentUser: {},
      dialogEdit: false,
      editType: "",
      orgIdMap: {},
    };
  },
  computed: {
    isIframe() {
      return window.location.href.indexOf("mainContractNumberTag") !== -1;
    },
    isOppein() {
      return (
        this.currentUser &&
        this.currentUser.orgNo &&
        this.currentUser.orgNo.toUpperCase() === "OPPEIN.COM"
      );
    },
  },
  components: {
    tableSelectAll,
    OrganizationSelect,
  },
  async mounted() {
    this.currentUser = await reqGetCurrentUser();
    this.$nextTick(() => {
      if (this.$refs.selectTable) {
        this.$refs.selectTable.init({ pageNum: 1, pageSize: 10 });
      }
      // 强制修改搜索表单中el-form-item__content的margin-left
      // this.$nextTick(() => {
      //   const contentElements = document.querySelectorAll(
      //     ".main-contract-number-tag .search-form-tag .el-form-item__content",
      //   );
      //   contentElements.forEach((el) => {
      //     el.style.marginLeft = "0";
      //   });
      // });
    });
  },
  methods: {
    /**
     * 取消编辑弹窗
     */
    cancelEditDialog() {
      this.editDialogVisible = false;
      this.$refs.editForm.clearValidate();
    },
    setMallLabel() {
      this.editForm.type = "org";
      this.editForm.orgId = this.isOppein ? "" : this.currentUser.orgId;
      this.editForm.no = this.isOppein ? "" : this.currentUser.orgNo;
      this.editForm.orgNo = this.isOppein ? "" : this.currentUser.orgNo;
      this.editForm.shopId = "";
      this.brandCategoryList = [];
      this.editForm.brandCategoryList = [];
      this.disabledBrandCategory = true;
      this.editForm.label = this.isOppein
        ? ""
        : this.editForm.label || this.currentUser.orgName;
      this.$nextTick(() => {
        if (this.$refs.orgSelect) {
          this.$refs.orgSelect.nameValue = this.isOppein
            ? ""
            : this.currentUser.orgName;
          this.$forceUpdate();
        }
      });
    },
    /**
     * 取号标签配置维度改变时处理
     */
    handleRadioChange(val) {
      this.$refs.editForm.clearValidate();
      if (this.editForm.radio === 1) {
        this.setMallLabel();
      } else {
        this.editForm.type = "shop";
        this.brandCategoryList = this.brandCategoryListCopy;
        this.disabledBrandCategory = false;
        this.editForm.no = "";
        if (this.$refs.orgSelect) {
          this.$refs.orgSelect.nameValue = "";
          this.$forceUpdate();
        }
      }
    },
    /**
     * 品牌品类选择改变时处理
     */
    handleBrandCategoryChange(val) {
      if (val.length) {
        console.log("val---", val);
      } else {
      }
    },
    onNodeClick(data) {
      this.editForm.shopId = data.id;
      this.editForm.no = data.no;
      this.editForm.name = data.name;
    },
    onCheckChange(data) {
      let ids = (data || []).reduce((ele, item) => {
        ele.push(item.id);
        return ele;
      }, []);
      console.log("ids---", ids, data);
    },
    async init() {
      await this.getCategoryOptions();
      this.getCustomerMainContactLabelQueryPage();
    },
    /**
     * 获取品类选项
     */
    async getCategoryOptions() {
      try {
        const list = await getDict("ROOT_category");
        this.categoryOptions = Array.isArray(list) ? list : [];
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * 根据组织ID查询组织详情
     */
    async selectOrgById(orgId, _type, _set) {
      try {
        if (orgId === "1" || (_set === "setObj" && this.orgIdMap[orgId]))
          return;
        const response = await api.uc.selectOrgById({ orgId });
        const resp = response.data || {};
        if (_type) {
          if (_set) {
            this.orgIdMap = {
              ...this.orgIdMap,
              [orgId]: resp.orgNo || "",
            };
          } else {
            this.editForm.orgNo = resp.orgNo || "";
          }
        } else {
          this.editForm.label = resp.orgSimpleName || "";
        }

        console.log("resp-----", resp);
        return resp;
      } catch (error) {
        console.error(error);
      }
    },
    async selectOrgByNo() {
      try {
        if (!this.editForm.orgNo) return;
        const response = await api.uc.selectOrgByNo({
          orgNo: this.editForm.orgNo,
        });
        const resp = response.data || {};
        if (this.editForm.radio === 1) {
          this.editForm.no = this.editForm.orgNo;
          this.$refs.orgSelect.nameValue = response.data.orgName || "";
          this.editForm.orgId = response.data.orgId || "";
          this.editForm.label = resp.orgSimpleName || "";
        }
        if (this.editForm.radio === 2) {
          sessionStorage.removeItem("organizationalStructureList");
          this.$refs.orgSelect.nameValue = "";
          this.editForm.no = "";
          this.editForm.orgId = response.data.orgId || "";
          this.editForm.label = resp.orgSimpleName || "";
        }

        console.log("selectOrgByNo-----", resp);
        // return resp;
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 搜索主合同号标签
     */
    async handleSearch() {
      this.$refs.selectTable.init({ pageNum: 1, pageSize: 10 });
    },
    /**
     * 主合同号标签分页查询
     */
    async getCustomerMainContactLabelQueryPage(
      page = { pageNum: 1, pageSize: 10 },
    ) {
      try {
        this.isLoading = true;
        const response = await queryPageByOrgPermissions({
          ...this.searchForm,
          orgIds: [this.currentUser.orgId || this.editForm.orgId],
          ...page,
          pageNo: page.pageNum || 1,
        });
        const resp = response.data || {};
        // .log("resp-----", resp);
        const conditionList = Array.isArray(resp.records) ? resp.records : [];
        await Promise.all(
          [...new Set(conditionList.map((item) => item.orgId))].map((item) => {
            this.selectOrgById(item, true, "setObj");
          }),
        );
        this.tableData = conditionList;
        this.tableData.forEach((item) => {
          let orgNo = this.orgIdMap[item.orgId]
            ? this.orgIdMap[item.orgId]
            : "";
          console.log(
            "orgNo-------",
            orgNo,
            this.orgIdMap[item.orgId],
            this.orgIdMap,
            item,
          );
          this.$set(item, "orgNo", orgNo);
        });
        return {
          pageNum: resp.current || 1,
          pageSize: resp.size || 10,
          total: resp.total || 0,
        };
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 加载品牌品类列表
     */
    async loadBrandCategoryList() {
      try {
        // 这里应该调用获取品牌品类列表的API
        // 示例数据，实际应替换为真实API调用
        const { data } = await reqGetOrgBrandCategory({
          orgId: this.editForm.orgId || this.currentUser.orgId,
        });
        let arr = data.map((item) => ({
          label: `${item.brandName}-${item.categoryName}`,
          value: `${item.brand}-${item.category}`,
        }));
        this.brandCategoryList = arr;
        this.brandCategoryListCopy = [...arr];
      } catch (error) {
        console.error("加载品牌品类列表失败:", error);
      }
    },
    /**
     * 导出主合同号取号标签
     */
    async downloadFile() {
      try {
        let params = {
          ...this.searchForm,
          orgIds: [this.currentUser.orgId],
        };
        linkPost("exportByOrgPermissions", params, "主合同号取号标签.xlsx");
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * 新增主合同号标签配置
     */
    async handleAdd() {
      this.editType = null;
      this.editDialogVisible = true;
      this.dialogEdit = false;
      this.editForm = {
        // id: "",
        // no: "",
        // name: "",
        // brandCategoryList: [],
        // label: "", // 默认为商场简称
        id: "",
        no: "",
        name: "",
        brandCategoryList: [],
        label: "",
        radio: null,
        orgId: "",
        orgNo: "",
        shopId: "",
        type: "",
      };
      this.editForm.radio = 1;
      this.setMallLabel();
      await this.selectOrgById(this.currentUser.orgId);
      await this.loadBrandCategoryList();
    },
    /**
     * 处理编辑
     */
    async handleEdit(row, _type) {
      // 初始化编辑表单数据
      this.editDialogVisible = true;
      this.dialogEdit = true;
      this.editType = _type || "edit";

      this.editForm = {
        id: row.id,
        no: row.no,
        name: row.name,
        brandCategoryList: [`${row.brand}-${row.category}`] || [],
        label: row.label || "", // 默认为商场简称
        shopId: row.shopId || "",
        orgId: row.orgId || "",
        orgNo: row.orgNo || "",
      };
      await this.selectOrgById(row.orgId, true);
      if (row.no === this.editForm.orgNo) {
        // this.currentUser.orgNo
        this.editForm.radio = 1;
        this.brandCategoryList = [];
        this.editForm.brandCategoryList = [];
        this.disabledBrandCategory = true;
        this.editForm.type = "org";
        this.editForm.orgId = row.orgId;
        this.editForm.no = this.editForm.orgNo;
        this.editForm.orgNo = this.editForm.orgNo;
        this.editForm.shopId = "";
      } else {
        // await this.selectOrgById(row.orgId, true);
        // this.editForm.orgNo = this.currentUser.orgNo;
        await this.loadBrandCategoryList();
        this.editForm.radio = 2;
        this.editForm.type = "shop";
        this.disabledBrandCategory = false;
      }
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate();
        if (this.$refs.orgSelect) {
          this.$refs.orgSelect.nameValue = row.name;
          this.$forceUpdate();
        }
      });
    },

    /**
     * 处理删除
     */
    async handleDelete(row) {
      try {
        await this.$confirm(
          "删除当前数据，主合同号取号将无法匹配该标签数据。请确认是否删除？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          },
        );

        // 这里应该调用删除API
        // 示例：await deleteMainContractNumberTag(row.id);
        await deleteByIdValidateOrgPermissions({
          id: row.id,
        });
        this.$message.success("删除成功");
        // 重新加载数据
        if (this.$refs.selectTable) {
          this.$refs.selectTable.init({ pageNum: 1, pageSize: 10 });
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除失败:", error);
          this.$message.error("删除失败");
        }
      }
    },

    /**
     * 提交编辑表单
     */
    async submitEditForm() {
      try {
        await this.$refs.editForm.validate(async (valid) => {
          if (valid) {
            // 准备提交数据
            const submitData = {
              ...this.editForm,
              ...(this.editType === "edit"
                ? {
                    brand:
                      this.editForm.brandCategoryList[0] &&
                      this.editForm.brandCategoryList[0].split("-")[0],
                    category:
                      this.editForm.brandCategoryList[0] &&
                      this.editForm.brandCategoryList[0].split("-")[1],
                  }
                : {}),
              brandCategoryList:
                this.editForm.type === "shop"
                  ? this.editForm.brandCategoryList.map((item) => {
                      if (typeof item === "string") {
                        const [brand, category] = item.split("-");
                        return {
                          id: this.editForm.id || "",
                          brand: brand || "",
                          category: category || "",
                          deleted: 0,
                        };
                      }
                      // 如果已经是对象格式，直接返回
                      return item;
                    })
                  : [
                      {
                        id: this.editForm.id || "",
                        brand: "",
                        category: "",
                        deleted: 0,
                      },
                    ],
            };
            console.log("submitData", submitData);
            let req =
              this.editType === "edit"
                ? updateByOrgPermissions
                : saveByOrgPermissions;
            const res = await req(submitData);
            if (res.status) {
              this.$message.success("保存成功");
              this.editDialogVisible = false;
              this.editType = "";
              // 重新加载数据
              if (this.$refs.selectTable) {
                this.$refs.selectTable.init({ pageNum: 1, pageSize: 10 });
              }
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } catch (error) {
        if (error !== "cancel") {
          console.error("保存失败:", error);
          this.$message.error("保存失败");
        }
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
// 全局样式，确保覆盖Element UI默认样式
body .main-contract-number-tag .search-form-tag .el-form-item__content {
  margin-left: 0 !important;
}

// 更激进的选择器，确保覆盖任何Element UI样式
body .el-form.search-form-tag .el-form-item .el-form-item__content {
  margin-left: 0 !important;
}

// 直接针对表单项目内容的全局覆盖
// body .el-form-item__content {
//   margin-left: 0 !important;
// }

// 编辑弹窗中el-input的背景色
.edit-dialog-tag
  .el-dialog
  .edit-dialog-form
  .edit-dialog-form-input
  .el-input__inner {
  background-color: #aaaaaa !important;
  color: #ffffff !important;
}
.edit-dialog-tag .get-org-btn .el-input__inner {
  width: 140px !important;
}
.main-contract-number-tag {
  .customer-data-package-table {
    .el-table th {
      background-color: #dceaff;
      color: #3f3f3f;
    }
  }
}
</style>

<style scoped lang="scss">
.main-contract-number-tag {
  > .isIframe {
    &::after {
      content: "";
      display: table;
      clear: both;
    }
    .el-form-item {
      margin-bottom: 0;
    }
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  > .title {
    color: var(--color-primary);
    font-size: 16px;
    font-weight: bold;
    border-left: 4px solid var(--color-primary);
    padding-left: 5px;
    // padding-bottom: 10px; // 添加一点底部内边距
    overflow: hidden; // 防止浮动元素溢出
    line-height: 28px;
    &::after {
      content: "";
      display: table;
      clear: both;
    }
    .el-form-item {
      margin-bottom: 0;
    }
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  > .setting-item {
    background-color: #f1f1f1;
    padding: 10px;
    line-height: 2.5em;
    margin: 0 0 10px 0;
    .apply-scope-setting {
      margin-left: 10px;
    }
    .customer-data-package-table {
      margin-top: 10px;
      .special-case-list-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .special-case-text {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 8px;
          text-align: left;
        }
      }
      .submission-methods-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .el-checkbox-group {
          display: flex;
          align-items: center;
        }
        .el-checkbox {
          margin-bottom: 0;
        }
        .el-button {
          margin-left: 10px;
        }
      }
    }
  }
  // 使用更具体的选择器来覆盖Element UI的默认样式
  .search-form-tag {
    .el-form-item {
      margin-bottom: 0;
    }
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  // 编辑弹窗中el-input的背景色
  .edit-dialog-tag
    .el-dialog
    .el-form
    .edit-dialog-form-input
    ::v-deep
    .el-input__inner {
    background-color: #aaaaaa !important;
    color: #ffffff !important;
  }
}
</style>



// WEBPACK FOOTER //
// mainContractNumberTag.vue?0216b985